import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { useRecoilState } from 'recoil';
import CompanyInformationWrite from 'components/community/interview/components/CompanyInformationWrite';
import InterviewContentsWrite from 'components/community/interview/components/InterviewContentsWrite';
import AcceptanceRedirectmodal from 'components/community/parts/modal/AcceptanceRedirectmodal';
import { createInterviewReview } from 'libs/api/community';
import { handleFieldError, moveToFirstError } from 'libs/api/errorHandle';
import {
  TInterviewReviewWrite,
  TInterviewContent,
  TInterviewFirmInfo,
  TInterviewReviewPostFormat,
  TInterviewContentPostFormat,
} from 'modules/community';
import { interviewFirmInfoState, completeModalVisibleState } from 'modules/community/recoilState';
import { TModalState } from 'modules/types';
import { CWindowWidth } from 'constants/base.const';
import { CInterviewRoundText } from 'constants/community.const';
import { ENotificationType } from 'enums/base.enum';
import { EEmploymentType, EInterviewFinalResult } from 'enums/community.enum';
import { ERoute } from 'enums/route.enum';
import { Divider, Form, Button } from 'antd';
import styled from 'styled-components';
import { Colors, FormWrapper, SecondaryColor, device, PrimaryColor } from 'GlobalStyles';

const InterviewReviewWrite = () => {
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
  const [acceptanceRedirectModal, setAcceptanceRedirectModal] = useState<TModalState>({ visible: false });
  const [interviewFirmInfo, setInterviewFirmInfo] = useRecoilState<TInterviewFirmInfo>(
    interviewFirmInfoState,
  );
  const [form] = Form.useForm();
  const history = useHistory();
  const [completeModalVisible, setCompleteModalVisible] = useRecoilState(completeModalVisibleState);

  const onClickTest = async () => {
    try {
      const values = await form.validateFields();
      console.log('Success:', values);
    } catch (errorInfo) {
      console.log('Failed:', errorInfo);
    }
  };

  const onClickSubmit = () => {
    form
      .validateFields()
      .then((value) => {
        handleSubmit(value as TInterviewReviewWrite);
      })
      .catch((errorInfo) => {
        // console.log('errorInfo', errorInfo);
        moveToFirstError(form, errorInfo.errorFields); //같은 컴포넌트 안에 Form,Item이 있어야 적용된다..
      });
  };

  const handleSubmit = async (value: TInterviewReviewWrite) => {
    const params: TInterviewReviewPostFormat = {
      company_name: {
        id: value.company_name_id ? value.company_name_id : null,
        company_name: value.company_name,
      },
      is_consulting_firm: value.is_consulting_firm,
      interview_result: value.interview_result,
      employment_type: value.employment_type,
      interview_date: moment(`${value.interview_date_year}-${value.interview_date_month}-10 12:00`).format(
        'YYYY-MM-DD HH:mm',
      ),
      interview_review: value.interview_review
        .filter(
          (el: TInterviewContent) =>
            el.interview_type?.length > 0 &&
            form.getFieldValue('interview_round_checkboxes').includes(el.interview_type[0]),
        )
        .map((el: any) => {
          return {
            ...el,
            fit_importance: el.fit_importance ? String(el.fit_importance) : null,
            case_importance: el.case_importance ? String(el.case_importance) : null,
            interview_type: `${CInterviewRoundText[String(el.interview_type[0])]}_interview`,
          };
        }),
    };

    try {
      setSubmitButtonDisabled(true);
      const { data, success } = await createInterviewReview(params);
      if (success) {
        setCompleteModalVisible(true);
        setInterviewFirmInfo({
          ...interviewFirmInfo,
          isConsultingFirm: false,
          interviewResult: '',
          employmentType: '',
        });
        history.push({
          pathname: ERoute.InterviewReviewBoard,
          state: {
            notification: {
              type: ENotificationType.Success,
              message: '인터뷰 후기 등록이 완료되었습니다.',
            },
          },
        });
      }
    } catch (e) {
      handleFieldError(e, form);
      throw e;
    } finally {
      setSubmitButtonDisabled(false);
    }
  };

  useEffect(() => {
    const { isConsultingFirm, interviewResult, employmentType } = interviewFirmInfo;
    if (
      isConsultingFirm &&
      interviewResult === EInterviewFinalResult.Pass &&
      employmentType !== EEmploymentType.GeneralTypeIntern &&
      employmentType !== ''
    ) {
      setAcceptanceRedirectModal({ ...acceptanceRedirectModal, visible: true });
    }
  }, [interviewFirmInfo]);

  return (
    <InterviewReviewWriteWrapper>
      <StyledHeader>
        <h1 className='title'>인터뷰 후기 등록하기</h1>
        <span className='expandComment'> * 등록한 내용은 익명으로 사용됩니다</span>
      </StyledHeader>

      <FormWrapper>
        <Form form={form} layout='vertical' className='form-normal' requiredMark={false}>
          <StyledSubItemContainer>
            <StyledSubItemTitle
              onClick={() => {
                // console.log(form.getFieldsValue());
                onClickTest();
              }}
            >
              기업정보 <br />
              등록하기
            </StyledSubItemTitle>
            <StyledSubItemWrite>
              <CompanyInformationWrite form={form} />
            </StyledSubItemWrite>
          </StyledSubItemContainer>
          <StyledSubItemContainer>
            <StyledSubItemTitle>
              인터뷰 <br />
              공유하기
            </StyledSubItemTitle>
            <StyledSubItemWrite>
              <InterviewContentsWrite form={form} />
            </StyledSubItemWrite>
          </StyledSubItemContainer>
          <div style={{ justifyContent: 'flex-end', marginTop: '50px' }}>
            <Form.Item>
              <Button
                className='ant-btn-primary large-padding'
                size='large'
                onClick={onClickSubmit}
                loading={submitButtonDisabled}
              >
                등록하기
              </Button>
            </Form.Item>
          </div>
        </Form>
      </FormWrapper>
      <AcceptanceRedirectmodal
        modalState={acceptanceRedirectModal}
        setModalState={setAcceptanceRedirectModal}
      />
    </InterviewReviewWriteWrapper>
  );
};

export default InterviewReviewWrite;

const InterviewReviewWriteWrapper = styled.div`
  max-width: ${CWindowWidth - 500}px;
  margin: 140px auto 0 auto;
  padding: 0px 50px;

  & .form-normal .ant-btn.large-padding {
    padding: 0px 100px !important;
  }
  @media screen and ${device.sm} {
    padding: 0 20px;
  }
`;

const StyledHeader = styled.header`
  display: flex;
  align-items: center;
  padding-bottom: 5px;
  border-bottom: 1px solid #e4e4e4;
  margin-bottom: 10px;
  & .title {
    margin: 0 10px 0 0;
    font-size: 24px;
    font-weight: 900;
    color: ${PrimaryColor};
  }
  & .expandComment {
    color: ${PrimaryColor};
  }
  @media screen and ${device.sm} {
    flex-direction: column;
    align-items: start;
  }
`;

const StyledSubItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  &:not(:first-child) {
    margin-top: 50px;
  }
  @media screen and ${device.sm} {
    flex-direction: column;
  }
`;

const StyledSubItemTitle = styled.div`
  /* margin-right: 80px; */
  font-size: 18px;
  font-weight: 900;
  color: ${SecondaryColor};
  @media screen and ${device.sm} {
    margin-bottom: 20px;
  }
`;

const StyledSubItemWrite = styled.div`
  width: 80%;
  @media screen and ${device.sm} {
    width: 100%;
  }
`;
